import { addressDrawerPickUpLocationSelectorStyles } from "@insite/content-library/Widgets/Header/AddressDrawerPickUpLocationSelector";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { css } from "styled-components";

addressDrawerPickUpLocationSelectorStyles.changeLink = {
    typographyProps: {
        size: 12,
        lineHeight: "17px",
        weight: fontConfig.weight.bold,
    },
    css: css`
        margin-left: 16px;
    `,
};
